export default {
    topics: [
        {
            title: ' baseType ',
            href: 'p-Enumeration-baseType.html',
            attributes: { 'data-id': 'p-Enumeration-baseType' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-baseType-d66e6604',
            topics: [],
        },
        {
            title: ' default ',
            href: 'p-Enumeration-default.html',
            attributes: { 'data-id': 'p-Enumeration-default' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-default-d66e6612',
            topics: [],
        },
        {
            title: ' description ',
            href: 'p-Enumeration-description.html',
            attributes: { 'data-id': 'p-Enumeration-description' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-description-d66e6620',
            topics: [],
        },
        {
            title: ' hasImage ',
            href: 'p-Enumeration-hasImage.html',
            attributes: { 'data-id': 'p-Enumeration-hasImage' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-hasImage-d66e6628',
            topics: [],
        },
        {
            title: ' label ',
            href: 'p-Enumeration-label.html',
            attributes: { 'data-id': 'p-Enumeration-label' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-label-d66e6636',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-Enumeration-name.html',
            attributes: { 'data-id': 'p-Enumeration-name' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-name-d66e6644',
            topics: [],
        },
        {
            title: ' values ',
            href: 'p-Enumeration-values.html',
            attributes: { 'data-id': 'p-Enumeration-values' },
            menu: { hasChildren: false },
            tocID: 'p-Enumeration-values-d66e6652',
            topics: [],
        },
    ],
};

